import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CategoryDemoContext from '../../utils/CategoryDemo/context';
import BankingTypeContext from '../../utils/BankingType/context';
import { masthead_demo } from './data/masthead_demo.json';
import { compileDisclosureText, BlobParam } from '../../utils/SiteTools';
import { lobDemoSplit } from '../../utils/LobLogicModule'
import { EnvGet } from '../../utils/EnvGet';
import * as SELECTORS from '../../constants/selectors';
import './MastheadDemo.scss';

/**
 * MastheadDemo component
 * Shows the H1 Tag of the Demo with a specific icon image on side
 */
const MastheadDemo = ({ content, pageRoute }) => {

	const { t, i18n } = useTranslation('masthead_demo');
	const sourceName = EnvGet();
	const [iconName, setIconName] = useState(null);
	const [iFrameBankingTypeURL, setIFrameBankingTypeURL] = useState('');
	const [iFrameLanguageURL, setIFrameLanguageURL] = useState('');
	const { categoryDemoData } = useContext(CategoryDemoContext);
	const { bankingType, setBankingType } = useContext(BankingTypeContext);
	const { search } = useLocation();

	useEffect(() => {

		document.title = content.title;
		
		// Set Banking Type Context from URL
		if (pageRoute !== undefined) { setBankingType(() => (pageRoute.match('online') ? SELECTORS.OLB : pageRoute.match('mpos') ? SELECTORS.MPOS : pageRoute.match('essentials') ? SELECTORS.ESSENTIALS : SELECTORS.MB )); };
		if (pageRoute !== undefined) { pageRoute.match('es-') ? i18n.changeLanguage('es') : i18n.changeLanguage('en') };

		// If the page is in IFRAME, need to append links - Banking type & Lang
		if (window.location.pathname.match('iframe')) {
			setIFrameBankingTypeURL(`/iframe/${bankingType === SELECTORS.OLB ? SELECTORS.MB : SELECTORS.OLB}`);
			setIFrameLanguageURL(`/iframe/${bankingType}`);
		}

		if(lobDemoSplit === '/sb') {
			content.category = 'smallbusiness';
		}
		
		// Filtered category Icon image on demo page
		setIconName(categoryDemoData.map(item => (item.path === content.category) && item.imgSmall).find(item => item));
	}, [content, categoryDemoData, pageRoute,  setBankingType, i18n, bankingType]);

	return (
		<section id="masthead" className="content_wrapper masthead masthead--demo" data-action="masthead">
			<div className="masthead__wrapper">
				{
					content.related.length > 0 &&
						<p className="related-links">
							{ (content.related[0].type?.mb || content.related[0].type?.olb) &&
								(bankingType === SELECTORS.OLB
									? <Link id="BankingType" data-component="Masthead" to={`${lobDemoSplit}${iFrameBankingTypeURL}/${content.related[0].type.mb+BlobParam(search)}`} className="related change-banking-type t-track-body-copy-link" data-bactmln="MastheadDemo-_-Hyperlink-_-mbVersion" dangerouslySetInnerHTML={{ __html: t(masthead_demo.related.type.mb) }} />
									: <Link id="BankingType" data-component="Masthead" to={`${lobDemoSplit}${iFrameBankingTypeURL}/${content.related[0].type.olb+BlobParam(search)}`} className="related change-banking-type t-track-body-copy-link" data-bactmln="MastheadDemo-_-Hyperlink-_-olbVersion" dangerouslySetInnerHTML={{ __html: t(masthead_demo.related.type.olb) }} />)
							}
							{ (content.related[0].lang?.en || content.related[0].lang?.es) &&
								<Link id="Language" data-component="Masthead" to={`${lobDemoSplit}${iFrameLanguageURL}/${ i18n.language === 'en' ? content.related[0].lang.es+BlobParam(search) : content.related[0].lang.en+BlobParam(search) }`} className="related change-language t-track-body-copy-link" data-bactmln={i18n.language === 'en' ? 'MastheadDemo-_-Hyperlink-_-EnEspanol' : 'MastheadDemo-_-Hyperlink-_-InEnglish'} dangerouslySetInnerHTML={{ __html: t(masthead_demo.related.lang) }} />
							}
						</p>
				}
				
				<p className="masthead__category--type" dangerouslySetInnerHTML={{ __html: content.type }}></p>
				<h1 className="masthead__category--title" dangerouslySetInnerHTML={{ __html: content.title }}></h1>
				<div className="masthead__category--copy" dangerouslySetInnerHTML={{ __html: compileDisclosureText(content.copy).join('') }}></div>
			</div>
			<div className="bground-image-wrapper">
				<img src={`${sourceName}${iconName}`} alt={`${content.title} Demo`} className="img-icon" />
			</div>
		</section>
	);
};

export default MastheadDemo;